import { render, staticRenderFns } from "./RequestTemplatesPage.vue?vue&type=template&id=1edebd6e&scoped=true"
import script from "./RequestTemplatesPage.vue?vue&type=script&lang=js"
export * from "./RequestTemplatesPage.vue?vue&type=script&lang=js"
import style0 from "./RequestTemplatesPage.vue?vue&type=style&index=0&id=1edebd6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edebd6e",
  null
  
)

export default component.exports